import { render, staticRenderFns } from "./USPCardContainer.vue?vue&type=template&id=221d3541&scoped=true&"
import script from "./USPCardContainer.vue?vue&type=script&lang=js&"
export * from "./USPCardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221d3541",
  null
  
)

export default component.exports